// extracted by mini-css-extract-plugin
export default {"card":"cardHero_card__fwwxj","icon":"cardHero_icon__6dSX4","header":"cardHero_header__EDWyY","paragraph":"cardHero_paragraph__8O4a-"};